<template>
<div class="container">
    <div class="row d-flex justify-content-start">

        <div class="col-8 mb-4">
            <h3 class="c-ndarkthree bold">
                <UserIcon :color="getPrimaryColorHex.four" />Minha conta
            </h3>
            <p class="c-ndarkfour">
                Acesse e edite seus dados cadastrados na plataforma.
            </p>
        </div>
        <div class="col-5 mt-2">
            <h4 class="c-ndarkfour medium">
                Dados pessoais
            </h4>
            <el-form :model="userInfo" ref="userInfo" :rules="rules" @keyup.native="validateForm">
                <div class="row mt-4">
                    <div class="col-12">
                        <el-form-item prop="name">
                            <InputText v-model="userInfo.name" label="Nome completo " placeholder="Camila Barboza Leão" />
                        </el-form-item>
                    </div>
                    <div class="col-12 mt-3">
                        <el-form-item prop="email">
                            <InputText ref="email" type="email" v-model="userInfo.email" label="E-mail " placeholder="mila.barbozaleao@gmail.com"/>
                        </el-form-item>
                    </div>

                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <el-form-item prop="cpf">
                            <InputText v-model="userInfo.cpf" label="CPF" placeholder="000.000.000-00" v-mask="'###.###.###-##'"/>
                        </el-form-item>
                    </div>
                    <div class="col-6">
                        <el-form-item prop="phoneNumber">
                            <InputText v-model="userInfo.phoneNumber" label="Telefone celular" placeholder="(00) 00000-0000" v-mask="'(##) #####-####'" autocomplete="off"/>
                        </el-form-item>
                    </div>
                </div>
            </el-form>
            <el-form @keydown.native="invalidCredetials = false" :model="passwordInfo" ref="passwordInfo">
                <div class="row mt-4">
                    <div class="col-12 mb-3">
                       <h4 class="c-ndarkfour medium">
                            Alterar senha
                        </h4>
                    </div>
                    <div class="col-12" style="height: 84px">
                        <el-form-item prop="password">
                            <!-- <InputText class="is-error" type="password" v-model="passwordInfo.password" label="Senha atual" placeholder="Senha atual" /> -->
                            <h6 class="regular" :class="this.invalidCredetials ? 'c-error' : ''">
                                Senha atual
                            </h6>
                            <el-input placeholder="Senha atual" native-type="password" v-model="passwordInfo.password" show-password @keydown.space.native.prevent :class="
                                `${this.invalidCredetials ? 'is-error' : this.passwordInfo.password.length ? 'is-success' : ''} ${getPrimaryColor}`"
                            />
                            <h6 class="mt-1 mb-0 password-strength-label regular" :class="this.invalidCredetials || !this.passwordFormValid ? 'c-error' : ''">
                                {{ this.invalidCredetials ? 'Ops! Parece que a sua senha atual não é essa.' : this.passwordInfo.newPassword.length && !this.passwordInfo.password.length ? 'Por favor, insira a sua senha!' : '' }}
                            </h6>
                        </el-form-item>
                    </div>
                    <div class="col-12 mt-3">
                        <el-form-item prop="newPassword">
                            <h6 class="regular">
                            Nova senha
                            </h6>
                            <el-input :class="`${getPrimaryColor} isSuccess`" placeholder="Nova senha" native-type="password" v-model="passwordInfo.newPassword" show-password @keydown.space.native.prevent />
                            <h6 class="mt-1 password-strength-label regular" :class="
                                    this.passwordInfo.newPassword.length < 1 ? 'c-white' :
                                    this.checkPassword.passwordStrength > 3 ? 'c-green' :
                                    this.checkPassword.passwordStrength > 1  ? 'Média': 'c-error'
                                ">
                                Força da senha:
                                {{
                                    !this.passwordInfo.newPassword.length ? '' :
                                    this.checkPassword.passwordStrength > 3 ? 'Forte' :
                                    this.checkPassword.passwordStrength > 1  ? 'Média': 'Fraco'
                                }}
                            </h6>
                        </el-form-item>
                    </div>
                </div>

                <div class="row mb-5">
                    <div class="col-12">
                        <p class="medium mb-3">
                            Sua senha deve ter:
                        </p>
                    </div>
                    <div class="col-6">
                        <p>
                            <check-icon class="c-green" v-show="checkPassword.sixSuccess"></check-icon>
                            <x-icon class="c-error" v-show="!checkPassword.sixSuccess"></x-icon>
                            Mínimo de 6 caracteres;
                        </p>
                    </div>
                    <div class="col-6">
                        <p>
                            <check-icon class="c-green" v-show="checkPassword.numberSuccess"></check-icon>
                            <x-icon class="c-error" v-show="!checkPassword.numberSuccess"></x-icon>
                            1 número;
                        </p>
                    </div>
                    <div class="col-6">
                        <p>
                            <check-icon class="c-green" v-show="checkPassword.upperSuccess"></check-icon>
                            <x-icon class="c-error" v-show="!checkPassword.upperSuccess"></x-icon>
                            1 letra maiúscula;
                        </p>
                    </div>
                    <div class="col-6">
                        <p>
                            <check-icon class="c-green" v-show="checkPassword.especialSuccess"></check-icon>
                            <x-icon class="c-error" v-show="!checkPassword.especialSuccess"></x-icon>
                            1 caractere especial
                        </p>
                    </div>
                </div>
            </el-form>
            <div class="row">
                <div class="col-12">
                    <Button :disabled="!formValid || !passwordFormValid" class="btn btn-blue" @click="profileUpdateRequest" :color="getPrimaryColor">
                        Salvar alterações
                    </Button>
                </div>
            </div>
        </div>
    </div>
    <ChangeUserEmail
        :dialogVisible="dialogVisibleChangeEmail"
        @closeModal="dialogVisibleChangeEmail=$event"
        @validateCode="validateCode"
    />
</div>
</template>

<script>
import UserIcon from '@/components/icons/User'
import validatePassword from '@/utils/validatePassword'
import validateEmail from '@/utils/validateEmail'
import emailCodeVerify from '@/api/emailCodeVerify'
import updateUserPassword from '@/api/updateUserPassword'
import updateUserData from '@/api/updateUserData'
import getUserData from '@/api/getUserData'
import userRules from '@/api/userRules'
import removeMask from '@/utils/removeMask'
import ChangeUserEmail from '@/components/modals/ChangeUserEmail'
import Vue from 'vue'
import {
    XIcon,
    CheckIcon,
} from 'vue-feather-icons';
export default {
    components: {
        UserIcon,
        XIcon,
        CheckIcon,
        ChangeUserEmail
    },
    data() {
        const invalidPassword = (_rule, _value, message) => {
            if (this.invalidCredetials) message('Ops! Parece que a sua senha atual não é essa.')
            else message()
        }
        const emailValidator = (_rule, _value, message) => {
            if (validateEmail(_value)) return message()
            else return message('Por favor, insira um e-mail válido')
        }
        return {
            userInfo: {
                name: this.$store.state.user.infos.name,
                email: this.$store.state.user.infos.email,
                cpf: this.$store.state.user.infos.cpf,
                phoneNumber: this.$store.state.user.infos.phoneNumber,
            },
            passwordInfo: {
                password: '',
                newPassword: '',
            },
            rules: {
                name: [
                    {
                        required: true,
                        message: 'Por favor, insira o seu nome',
                        trigger: 'blur'
                    },
                ],
                email: [
                    {
                        required: true,
                        message: 'Por favor, insira o e-mail',
                        trigger: 'blur'
                    },
                    {
                        validator: emailValidator,
                        trigger: 'blur'
                    },
                ],
/*                 cpf: [
                    {
                        required: true,
                        message: 'Por favor, insira o CPF',
                        trigger: 'blur'
                    },
                ], */
            },
            formValid: true,
            passwordRules: {
                password: [
                    {
                        validator: invalidPassword,
                        trigger: 'blur'
                    }
                ],
            },
            invalidCredetials: false,
            dialogVisibleChangeEmail: false,
        }
    },
    computed: {
        checkPassword: function () {
            return validatePassword(this.passwordInfo.newPassword)
        },
        checkedPassword: function () {
            return this.checkPassword.sixSuccess && this.checkPassword.numberSuccess && this.checkPassword.upperSuccess && this.checkPassword.especialSuccess
        },
        isSuccess: function () {
            return this.checkedPassword ? 'is-success' : ''
        },
        passwordFormValid() {
            const { password, newPassword } = this.passwordInfo
            if (!password.length && !newPassword.length) return true
            if (password.length && this.checkedPassword) {
                return true
            } else {
                return false
            }
        }
    },
    methods: {
        validateForm() {
            this.$refs['userInfo'].validate((valid) => {
                if (valid) {
                    this.formValid = true
                } else {
                    this.formValid = false
                }
            });
        },
        async profileUpdateRequest() {
            let resultPassword = true
            let isEmailValid = true
            const currentEmail = this.$store.state.user.infos.email
            const userInfoUnmasked = {
                ...this.userInfo,
                cpf: removeMask(this.userInfo.cpf),
                phoneNumber: removeMask(this.userInfo.phoneNumber),
            }
            if (userInfoUnmasked.email && userInfoUnmasked.email != currentEmail) {
                const correctEmailFormat = validateEmail(userInfoUnmasked.email)
                if (correctEmailFormat) {
                    userInfoUnmasked['currentEmail'] = currentEmail
                } else {
                    isEmailValid = false
                }
            }
            if (this.passwordInfo.password.length && this.checkedPassword) {
                const resultPasswordRequest = await updateUserPassword(this.passwordInfo)
                resultPassword = resultPasswordRequest.data.ok
                if (resultPasswordRequest.data.ok ==  false && resultPasswordRequest.data.message == 'current password is incorrect') {
                    this.invalidCredetials = true
                    this.$refs['passwordInfo'].validateField('password')
                }
            }
            const resultUser = await updateUserData(userInfoUnmasked)
            if ( resultUser.ok && resultPassword && isEmailValid ) {
                if (userInfoUnmasked.currentEmail) return this.dialogVisibleChangeEmail = true
                this.$notify({
                    title: 'Alterações salvas com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false
                });
                await getUserData(this.$store.state.user.token)
            } else {
                this.$notify({
                    title: 'Opa! Encontramos algum erro.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
        async validateCode(code) {
            const result = await emailCodeVerify({ verificationCode: code, partner: this.getWhiteLabel })
            if (result.ok) {
                await updateUserData({
                    email: this.userInfo.email,
                    allowEmailChange: true,
                })
                this.dialogVisibleChangeEmail = false
                this.$notify({
                    title: 'Alterações salvas com sucesso.',
                    message: '',
                    type: 'success',
                    duration: 3000,
                    offset: 100,
                    showClose: false
                });
            } else {
                this.$notify({
                    title: 'Código de confirmação inválido.',
                    message: '',
                    type: 'error',
                    duration: 3000,
                    offset: 100,
                    showClose: false,
                    customClass: 'error'
                });
            }
        },
    },
    async created() {
        await getUserData(this.$store.state.user.token)
        await userRules()
        const { cpf, name, email } = this.userInfo
        if (cpf && name && email) this.formValid = true
    },
    mounted() {
        Vue.nextTick(() => {
            this.$refs.email.$emit('change')
        })
    }

}
</script>

<style lang="scss" scoped>
.password-strength-label {
    font-weight: 400;
}

.width-880 {
    max-width: 880px;
}
</style>
